import $ from 'jquery';

$('.case-studies-overview__filter-link').on('click', function(e) {
    var target = $(this).data('target');
    var $teaser = $(this).parents('.case-studies-overview').find('.case-studies-overview__item');

    e.preventDefault();

    if(target !== 0) {
        $teaser.each(function(i) {
            var cats = $(this).data('categories'); //meow

            if(cats.length > 0) {

                var hit = 0;

                $(cats).each(function(i) {
                    console.log('target: ' + target);
                    console.log('cats: ' + cats[i]);


                    if(target === cats[i]) {
                        hit = 1;
                        console.log('hit');
                    }
                });

                console.log("----------------");

                if(hit === 1) {
                    console.log($teaser[i]);
                    $teaser.eq(i).addClass('case-studies-overview__item--visible');
                }
                else {
                    console.log($teaser[i]);
                    $teaser.eq(i).removeClass('case-studies-overview__item--visible');
                }
            }
            else {
                $teaser.eq(i).removeClass('case-studies-overview__item--visible');
            }
        });
    }
    else {
        $teaser.addClass('case-studies-overview__item--visible');
    }

});
